import {
  deleteApi,
  getApi,
  getApiById,
  postApi,
  putApi,
} from '../../Shared/Services/RestService';
import { PaginationResponse } from '../../Shared/Pagination/PaginationResponse';
import {
  AdminModuleDef,
  AdminRole,
  AdminRolePayload,
  AdminUserReference,
  RoleAssignmentAnalytics,
  UserCategory,
} from '../Types/AdminRoleType';

const ROLES = '/admin/roles';
const ASSIGNMENTS = '/admin/role-assignments';

export const getAdminRoles = (params?: {
  search?: string;
  status?: string;
  page?: number;
  size?: number;
}) => {
  return getApi<PaginationResponse<AdminRole>>(ROLES, params);
};

export const getActiveAdminRoles = () => {
  return getApi<AdminRole[]>(`${ROLES}/active`);
};

export const getAdminRole = (id: string) => {
  return getApiById<AdminRole>(ROLES, id);
};

export const createAdminRole = (payload: AdminRolePayload) => {
  return postApi<AdminRole>(ROLES, payload);
};

export const updateAdminRole = (id: string, payload: AdminRolePayload) => {
  return putApi<AdminRole>(ROLES, id, payload);
};

export const deleteAdminRole = (id: string) => {
  return deleteApi<null>(ROLES, id);
};

export const getAdminModules = () => {
  return getApi<AdminModuleDef[]>(`${ROLES}/modules`);
};

export const fetchCurrentPrivileges = () => {
  return getApi<string[]>(`${ROLES}/me/privileges`);
};

export const getAdminUsers = (search?: string) => {
  return getApi<AdminUserReference[]>(`${ASSIGNMENTS}/users`, search ? { search } : undefined);
};

export const getUsersByCategory = (category: UserCategory, search?: string) => {
  return getApi<AdminUserReference[]>(`${ASSIGNMENTS}/users/category`, { category, ...(search ? { search } : {}) });
};

export const getRoleAnalytics = () => {
  return getApi<RoleAssignmentAnalytics[]>(`${ASSIGNMENTS}/analytics`);
};

export const getUsersByAdminRole = (roleId: string, search?: string) => {
  return getApi<AdminUserReference[]>(`${ASSIGNMENTS}/role/${roleId}/users`, search ? { search } : undefined);
};

export const assignAdminRole = (payload: { userId: string; roleId: string }) => {
  return postApi<AdminUserReference>(`${ASSIGNMENTS}/assign`, payload);
};

export const unassignAdminRole = (userId: string) => {
  return postApi<AdminUserReference>(`${ASSIGNMENTS}/unassign/${userId}`, {});
};
